import { useQuery } from '@tanstack/react-query';
import { getDistinctValuesForFilter } from './getGLControlData';

export interface LedgerOption {
  label: string;
  value: string;
}

const fetchLedgerNames = async (
  controlId: string,
  selectedRegions: string[]
): Promise<LedgerOption[]> => {
  if (controlId !== 'grc18956') {
    return [];
  }
  const ledgerNames = await getDistinctValuesForFilter(
    controlId,
    'ledger_name',
    undefined,
    undefined,
    selectedRegions
  );
  return ledgerNames.map((ledger) => ({ label: ledger, value: ledger }));
};

export const useLedgerName = (controlId: string, selectedRegions: string[] = []) => {
  return useQuery({
    queryKey: ['ledgerNames', controlId, selectedRegions],
    queryFn: () => fetchLedgerNames(controlId, selectedRegions),
    enabled: Boolean(controlId && selectedRegions.length > 0),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
